/* What a client's notes on file say about the technicians on the board.
 *
 * Mangomint keeps free-text notes on a client's file, and some of them are
 * instructions to the desk about who the client should and should not be
 * booked with: "Do not book with Zenny". The board cannot read intent out of
 * free text, and does not try. What it can do is notice that a note names a
 * technician, and say so wherever it is about to hand that client to them
 * (Kevin, 2026-10-25) — the desk reads the note and decides.
 *
 * So any mention counts, not only "do not book": "prefers Zenny" is just as
 * worth a look before Zenny's client is moved to somebody else, and a rule that
 * guessed at the wording would miss the note written some other way.
 *
 * Pure; this file imports nothing.
 */

function escapeRe(s) {
  return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/* Does `notes` name this technician? A whole word, any case, so "Ann" is not
 * found in "Anna" or "annual", and "Zenny's" still names Zenny. `name` is the
 * board's name for them; a name of more than one word is also matched on its
 * first word, which is how a note usually refers to somebody. Single letters
 * and blanks match nothing. */
export function notesMention(notes, name) {
  if (!notes || !name) return false;
  var text = String(notes);
  var full = String(name).trim();
  if (full.length < 2) return false;
  var tries = [full];
  var first = full.split(/\s+/)[0];
  if (first !== full && first.length >= 2) tries.push(first);
  return tries.some(function (n) {
    var re = new RegExp('(^|[^\\p{L}\\p{N}])' + escapeRe(n) + '(?![\\p{L}\\p{N}])', 'iu');
    return re.test(text);
  });
}
